import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        range: 0
    },
    getters: {
        // getWidth(state) {
        //     return state.width
        // }

        getRange(state) {
            return state.range
        }
    },
    mutations: {
        // setWidth(state, payload) {
        //     state.width = payload
        // }
        setRange(state, payload) {
            state.range = payload.range
        }
    },
    actions: {
        // setWidth({
        //     commit
        // }) {
        //     commit('setWidth', window.innerWidth)
        // }

        setRange(context, payload) {
            context.commit('setRange', {
                range: payload.range
            })
        }
    }
})